module.exports = __webpack_public_path__ + "img/d58363c.png";